<ng-template #content let-modal>
    <div class="modal-header" style="    border: none;">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <div class="modal-body pb-5">
        <h1 class="modal-title">Create FREE account</h1>
      <h6 class="mt-4">to use all features</h6>
      <div class="badge_buttons justify-content-center">
        <a class="btn btn-modal-dark login" (click)="goToSignIn()">Login</a>
        <a class="btn btn-modal-dark signin" (click)="goToSignUp()">Sign up</a>
      </div>
  
      <div class="account_badge_footer   mt-4">
        <span
        style="margin-top: 20px; color: #000000; font-size: 16px; font-weight: 500; ;">Login
        with social media</span>
      <br />
      </div>
  
      <div style="display: flex;justify-content: center;" class="mt-2">
        <div id="google" (click)="googleLogin()" style="cursor: pointer;" class="mb-4">
          <img src="../../assets/images/google.svg" alt="googlebtn" />
        </div>
      </div>
    </div>
  </ng-template>